/**
 * Safely parses an HTML string containing <ul><li> items and returns an array of text strings.
 */
export function parseBulletPoints(htmlString: string): string[] {
  if (!htmlString) return []

  // Extract content between <li> and </li> tags
  const liRegex = /<li[^>]*>(.*?)<\/li>/gi
  const matches = []
  let match

  while ((match = liRegex.exec(htmlString)) !== null) {
    // Remove any nested HTML tags from the matched content
    const cleanText = match[1].replace(/<[^>]*>?/gm, '').trim()
    if (cleanText) {
      matches.push(cleanText)
    }
  }

  return matches
}
